import { render, staticRenderFns } from "./TrendIcon.vue?vue&type=template&id=f4e664b4&scoped=true"
import script from "./TrendIcon.vue?vue&type=script&lang=js"
export * from "./TrendIcon.vue?vue&type=script&lang=js"
import style0 from "./TrendIcon.vue?vue&type=style&index=0&id=f4e664b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e664b4",
  null
  
)

export default component.exports